import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  headerContainerStyle: {
    paddingTop: 30,
    alignItems: 'center',
    flexDirection: 'row',
    paddingBottom: 16.5,
  },
  backButtonContainerStyle: {
    position: 'absolute',
    left: 15,
    paddingTop: 20,
  },
  closeButtonContainer: {
    position: 'absolute',
    right: 15,
    top: 20,
  },
});
